import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-send-questionnaire-email-modal";

const keys = addTranslations(RESOURCE_NAME, {
    modal_title: {
        en: "Send emails",
        fr: "Envoyer des emails",
    },
    default_subject: {
        en: "New CSR data collection campaign",
        fr: "Nouvelle campagne de collecte de données RSE",
    },
    subject_placeholder: {
        en: "Subject",
        fr: "Sujet",
    },
    subject_hint: {
        en: "The subject of the email that will be sent to the supplier",
        fr: "Le sujet de l'email qui sera envoyé au fournisseur",
    },
    sender_name_placeholder: {
        en: "Sender name",
        fr: "Nom de l'expéditeur",
    },
    sender_name_hint: {
        en: "The name of the sender of the email",
        fr: "Le nom de l'expéditeur de l'email",
    },
    error_cannot_be_empty: {
        en: "This field cannot be empty",
        fr: "Ce champ ne peut pas être vide",
    },
    email_content_hint: {
        en: "The content of the email",
        fr: "Le contenu de l'email",
    },
    select_users: {
        en: "Select recipients",
        fr: "Sélectionner des destinataires",
    },
    select_users_hint: {
        en: "The people who will receive the email",
        fr: "Les personnes qui recevront l'email",
    },
    test_button: {
        en: "Test",
        fr: "Tester",
    },
    test_button_tooltip: {
        en: "Send a test email to yourself",
        fr: "Envoyer un email de test à vous-même",
    },
    send_button: {
        en: "Send",
        fr: "Envoyer",
    },
    cancel_button: {
        en: "Cancel",
        fr: "Annuler",
    },
});

export function useSendQuestionnaireEmailModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
